import { Injectable } from "@angular/core";
import { PlotResultGroup, TipDefectResultData } from "../../_objects/remeasurement";
import { MEASUREMENT_MODE } from "../../app.constants";

@Injectable({
  providedIn: 'root'
})
export class MeasurementResultFactory {
  public static createMeasurementResult(resultGroup: PlotResultGroup) : MeasurementResult {
    return { id: resultGroup.id, mode: resultGroup.mode, measurements: this.getMeasurementsByMode(resultGroup) };
  }

  public static createMissingCornerResult(tipDefectData: TipDefectResultData, id: string) : MeasurementResult {
    return { id: id, mode: MEASUREMENT_MODE.MISSING_CORNER, measurements: [
      { label: "area", value: tipDefectData.defectSurface, unit: MeasurementUnit.MM_Squared },
      { label: "l1", value: tipDefectData.edge1Distance, unit:MeasurementUnit.MM },
      { label: "l2", value: tipDefectData.edge2Distance, unit:MeasurementUnit.MM },
      { label: "radius", value: tipDefectData.tipAngle, unit:MeasurementUnit.Degree },
    ] };
  }

  private static getMeasurementsByMode(resultGroup: PlotResultGroup): MeasurementEntry[] {
    switch (resultGroup.mode) {
      case MEASUREMENT_MODE.LINES :
        return [
          { label: "totalLength", value: resultGroup.length, unit: MeasurementUnit.MM },
          { label: "currentSegmentLength", value: resultGroup.latestDistance, unit: MeasurementUnit.MM },
          { label: "objectDistance", value: resultGroup.objectDistance, unit: MeasurementUnit.MM },
        ];

      case MEASUREMENT_MODE.DEPTH :
        return  [
          { label: "depth", value: resultGroup.length, unit: MeasurementUnit.MM },
          { label: "objectDistance", value: resultGroup.objectDistance, unit: MeasurementUnit.MM },
        ];

      case MEASUREMENT_MODE.POINT_TO_LINE:
        return  [
          { label: "length", value: resultGroup.length, unit: MeasurementUnit.MM },
          { label: "objectDistance", value: resultGroup.objectDistance, unit: MeasurementUnit.MM },
        ];
      case MEASUREMENT_MODE.DISTANCE :
        return  [
          { label: "distance", value: resultGroup.length, unit: MeasurementUnit.MM },
          { label: "objectDistance", value: resultGroup.objectDistance, unit: MeasurementUnit.MM },
        ];
      case MEASUREMENT_MODE.AREA :
        return  [
          { label: "area", value: resultGroup.area, unit: MeasurementUnit.MM_Squared },
          { label: "perimeter", value: resultGroup.length, unit: MeasurementUnit.MM },
          { label: "objectDistance", value: resultGroup.objectDistance, unit: MeasurementUnit.MM },
        ];
      default: return [];
    }
  }

}

export type MeasurementResult = {
  id: string;
  mode: string;
  measurements: MeasurementEntry[]
}

export type MeasurementEntry = {
  value: number;
  label: string;
  unit: MeasurementUnit
}

export enum MeasurementUnit {
  MM,
  MM_Squared,
  Inch,
  Inch_Squared,
  Degree
}
